import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "msi-form" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "msi-content" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("导出")

import {ref} from 'vue'
// import { getSortRecord} from '@/service/main/statistical';
import { ElMessage, ElMessageBox } from 'element-plus';
import { exportExcel } from "@/utils/exportExcel";
import {outInTypeEnum } from '@/utils/enum'
import Pagination from '@/components/Pagination/index.vue'   
    //查询
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const formModel = ref({
        pageNo: 1,
        pageSize: 10,
        orderNo: "",
        wareContainerCode: "",
        wareMaterialCode: "",
        wareMaterialName: "",
        createdUserName: "",
        beginDate: "",
        endDate: "",
        finishDate:[]
    });

    //仓库类型列表
    let tableData = ref([]);

    //列表的数据条数
    const totalItems = ref<number>(0);

    //获取菜单列表
    // const getTabelData = () => {
    //     //判断完成时间是否有选择
    //     if(formModel.value.finishDate.length > 0) {
    //         formModel.value.beginDate = formModel.value.finishDate[0];
    //         formModel.value.endDate = formModel.value.finishDate[1];
    //     }
    //     getSortRecord(formModel.value).then(res => {
    //         if(res.code == 200) {
    //         const {data} = res;
    //         const result = data;
    //         tableData.value = result.rows;
    //         totalItems.value = result.totalRows;
    //         }else {
    //         ElMessage.error(`${res.code}:${JSON.stringify(res.message)}`)
    //         } 
    //     }).catch(err => {
    //         console.log(err)
    //         ElMessage.error(err)
    //     })
    // }

    // getTabelData();

    //重置搜索
    const resetForm = () => {
      formModel.value = {
        pageNo: 1,
        pageSize: 10,
        orderNo: "",
        wareContainerCode: "",
        wareMaterialCode: "",
        wareMaterialName: "",
        createdUserName: "",
        beginDate: "",
        endDate: "",
        finishDate:[]
    }
      getTabelData();
    }

    //选中的行
    const checkRows = ref<{id:number}[]>([]);

    // 选择
    const handleSelectionChange = (val: any) => {
      checkRows.value = val;
    }
    //导出
    const handExport = () => {
      let entozh = {
          id: "序号",
          orderNo: "出库单号",
          wareMaterialCode: "物料编号",
          wareMaterialName: "物料名称",
          quantity: "分拣数",
          wareLocationCode: '库位',
          wareContainerCode: '容器编号',
          createdUserName: '分拣人',
          createdTime: "完成时间"
        };
      exportExcel(checkRows.value, entozh, "xlsx", "分拣记录信息表");
    }


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: formModel.value,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "出库单号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.orderNo,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formModel.value.orderNo) = $event)),
                        clearable: "",
                        placeholder: "请输入出库单号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "物料名称:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.wareMaterialName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formModel.value.wareMaterialName) = $event)),
                        clearable: "",
                        placeholder: "请输入物料名称"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "物料编号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.wareMaterialCode,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formModel.value.wareMaterialCode) = $event)),
                        clearable: "",
                        placeholder: "请输入物料编号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "分拣人:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.createdUserName,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formModel.value.createdUserName) = $event)),
                        clearable: "",
                        placeholder: "请输入分拣人"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "容器编号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.wareContainerCode,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formModel.value.wareContainerCode) = $event)),
                        clearable: "",
                        placeholder: "请输入容器编号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "分拣时间:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: formModel.value.finishDate,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formModel.value.finishDate) = $event)),
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "value-format": "YYYY-MM-DD",
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: "el-icon-search",
                        onClick: _ctx.getTabelData
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_el_button, {
                        icon: "el-icon-refresh-right",
                        onClick: resetForm
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "info",
            plain: "",
            icon: "el-icon-upload2",
            disabled: checkRows.value.length == 0,
            onClick: handExport
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createVNode(_component_el_table, {
        data: _unref(tableData),
        border: "",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "序号",
            type: "index",
            width: "60",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "出库单号",
            prop: "orderNo",
            width: "200",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "物料编号",
            prop: "wareMaterialCode",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "物料名称",
            prop: "wareMaterialName",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "分拣数",
            prop: "quantity",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "库位",
            prop: "wareLocationCode",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "容器编号",
            prop: "wareContainerCode",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "分拣人",
            prop: "createdUserName",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "完成时间",
            prop: "createdTime",
            align: "center",
            "show-overflow-tooltip": ""
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(Pagination, {
        total: totalItems.value,
        page: formModel.value.pageNo,
        "onUpdate:page": _cache[6] || (_cache[6] = ($event: any) => ((formModel.value.pageNo) = $event)),
        limit: formModel.value.pageSize,
        "onUpdate:limit": _cache[7] || (_cache[7] = ($event: any) => ((formModel.value.pageSize) = $event)),
        onPagination: _ctx.getTabelData,
        style: {"margin-top":"20px","text-align":"center"}
      }, null, 8, ["total", "page", "limit", "onPagination"])
    ])
  ], 64))
}
}

})